import {Card} from "../../generic/card";
import {AsRoute} from "../../../app";

export function ConfigurationAdmin(props: AsRoute) {
    return <Card title={"Configuration"}></Card>;
}
